'use client'

import type { PrefetchMode } from '@pearlconvert/ui/components/link/link.types'

import React, { ReactNode } from 'react'
import { SkeletonTheme } from 'react-loading-skeleton'

import { useFocusMode } from '@pearlconvert/ui/hooks/use-focus-mode'
import {
  BreakpointProvider,
  DisabledPageScrollProvider,
  ForesightProvider,
  PrefetchModeProvider,
} from '@pearlconvert/ui/providers'

export const UiProvider = ({
  children,
  prefetchMode = 'off',
}: {
  children: ReactNode
  prefetchMode?: PrefetchMode
}) => {
  useFocusMode()

  return (
    <SkeletonTheme
      baseColor="var(--skeleton__color--base)"
      highlightColor="var(--skeleton__color--highlight)"
      borderRadius="var(--skeleton__border-radius)"
      inline
    >
      <BreakpointProvider>
        <DisabledPageScrollProvider>
          <PrefetchModeProvider mode={prefetchMode}>
            <ForesightProvider>{children}</ForesightProvider>
          </PrefetchModeProvider>
        </DisabledPageScrollProvider>
      </BreakpointProvider>
    </SkeletonTheme>
  )
}
